import { Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { getLastSevenDays } from "../../../../utils";

const BarChart = ({
  dataLabels,
  colors,
  datasets,
}: {
  dataLabels: string[];
  colors?: boolean;
  datasets: number[];
}) => {
  const lastSevendaysFormatted: string[] = [];
  getLastSevenDays().forEach((date) => {
    lastSevendaysFormatted.push(date.toDateString());
  });

  return (
    <Bar
      id="chart"
      data={{
        labels: dataLabels,
        datasets: [
          {
            label: "",
            // data: dataLabels.map(() => 1),
            data: datasets,

            backgroundColor: colors
              ? [
                  "#D9B64E",
                  "#2B6CB0",
                  "#0FCA98",
                  "#F27141",
                  "#008080",
                  "#00adad",
                  "#d600d6",
                  "#ffde24",
                  "#bc8e52",
                  "#570000",
                ]
              : ["#0FCA98"],
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: "bottom",
            align: "start",
            display: false,
          },
        },
      }}
    />
  );
};

export default BarChart;
